<template>
  <div class="col-12">
    <div class="card card-body card-panel-box border-0">
      <div class="d-flex justify-content-between align-items-center">
        <h2 style="font-size: 1.2vw !important;">اطلاعات  اثر </h2>
      </div>
      <form class="needs-validation mt-2 mb-3" novalidate>

        <div class="d-flex flex-nowrap w-100 justify-content-evenly">
          <div class="col-3 mb-3 ms-n-1" style="width: 12vw;">
            <label class="form-label ">دوره پایش </label>
            <select v-model="period" class="form-select" name="" id="" disabled>
              <option value="روزانه">روزانه</option>
              <option value="هفتگی">هفتگی</option>
              <option value="ماهانه">ماهانه</option>
              <option value="6 ماهه">6ماهه</option>
              <option value="فصلی">فصلی</option>
              <option value="سالانه"> سالانه</option>
              <option value="3 ساله">3 ساله</option>
            </select>

          </div>
          <div style="width: 12vw;" class="col-4 mb-3 ms-n-1">
            <label class="form-label">تاریخ شروع </label>
            <Vue3PersianDatetimePicker v-model="start_date" disabled  />

          </div>
          <div style="width: 12vw;" class="col-4 mb-3 ms-n-1">
            <label class="form-label">تاریخ پایان </label>
            <Vue3PersianDatetimePicker v-model="end_date" disabled />

          </div>

          <div style="width: 10vw;" class="col-lg-3 mb-3 ms-n-1">
            <label class="form-label"> واحد سنجش </label>
            <select v-model="unit" class="form-select" name="" id="" disabled>
              <option v-for="item in units" :value="item.id" >{{ item.name }}</option>

            </select>
          </div>
          <div style="width: 10vw;" class="col-lg-3 mb-3 ms-n-1">
            <label class="form-label"> مقیاس پیش فرض </label>
            <input disabled v-model="scale" class="form-control" type="text" name="" required>
          </div>



        </div>
      </form>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 35%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";

export default {
  components: {Vue3PersianDatetimePicker},
  props: ['units'],
  data() {
    return {
      start_date: '',
      end_date: '',
      period: '',
      unit: '',
      scale: '',
      errorMessage: '',
      error: false,
      id_route: this.$route['params']['id'],

    }
  },
  methods: {
    fetch() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/effect_information/show_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.item){
              this.unit = response.item.units_id
              this.period = response.item.period
              this.start_date = response.item.start_date
              this.end_date = response.item.end_date
              this.scale = response.item.default_scale
            }


          })
          .catch();
    },
    submit() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      const toast = useToast();


      var formdata = new FormData();
      formdata.append('units_id', this.unit);
      formdata.append('period', this.period);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('default_scale', this.scale);


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/effect_information/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)

              return
            }
            toast.success('اطلاعات اثر با موفقیت ثبت شد!')


          })
          .catch();
    },
  },
  mounted() {
    this.fetch()
  }

}
</script>

<style scoped>

</style>